import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Modal, Button, Icon } from 'antd';

import {
  schoolquotaInsert,
  schoolquotaList
} from '../../../modules/schoolquota';

import SchoolQuotaDetails from '../form/SchoolQuotaDetails';

class AddSchoolQuotaModal extends Component {
	constructor(props){
		super(props);
		this.state = {
			loading: false,
		}
	}

	onClose() {
		this.setState({ 	
			step: 0,
		});
		this.props.toggleAddModal();
	}

	onAdded() {
		this.setState({ 	
			step: 0,
		});
		this.props.toggleAddModal();
		this.props.schoolquotaList();
	}

	render() {
    const { loading } = this.state;
    const { selected } = this.props;

		return (
			<Modal
				title={<span><Icon type="file-add" /> {selected ? `編輯學校限額` : '新增學校限額'}</span>}
				visible={this.props.show}
				onCancel={()=>this.onClose()}
				footer={[
					<Button key="back" onClick={()=>this.onClose()} disabled={loading}>取消</Button>
				]}
				maskClosable={false}
				closable={(loading) ? false : true}
			>
				<SchoolQuotaDetails data={selected} callback={()=>this.onAdded()} show={this.props.show} />
			</Modal>
		);
	}
}

const mapStateToProps = state => ({
	router: state.router,
	userProfile: state.user.userProfile
});

const mapDispatchToProps = dispatch =>
bindActionCreators(
	{
		schoolquotaInsert,
		schoolquotaList,
	},
	dispatch
);

export default connect(mapStateToProps, mapDispatchToProps)(AddSchoolQuotaModal);